//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import 'vue-pdf-app/dist/icons/main.css'
import PDFMerger from 'pdf-merger-js/browser'
import { AXIOS } from '../../axios/axios.js'

export default {
  name: 'PdfFileViewer',
  components: {
    VuePdfApp: () => import('vue-pdf-app')
  },
  data () {
    return {
      files: [],
      shownFile: {},
      showViewer: false,
      readonly: false,
      numberInputValue: '',
      mergedPdfs: null,
      loading: false
    }
  },
  mounted: function () {
    this.addGlobalListeners()
  },
  beforeDestroy: function () {
    this.removeGlobalListeners()
  },
  computed: {
    viewerConfig: function () {
      return {
        toolbar: {
          toolbarViewerRight: {
            print: !this.readonly,
            download: !this.readonly && !this.shownFile.download
          }
        }
      }
    },
    showFooterFileControls: function () {
      return this.files.length > 1 && !this.mergedPdfs
    }
  },
  methods: {
    addGlobalListeners: function () {
      document.addEventListener('keyup', this.onKeyUp)
    },
    removeGlobalListeners: function () {
      document.removeEventListener('keyup', this.onKeyUp)
    },
    onKeyUp: function (e) {
      if (e.key == 'ArrowLeft') {
        this.changeShownFile(this.shownFile.number - 2)
      } else if (e.key == 'ArrowRight') {
        this.changeShownFile(this.shownFile.number)
      }
    },
    afterCreated: function () {
      console.log('PDF viewer: created')
      this.visible = true
    },
    changeShownFile: async function(index) {
      if (index >= 0 && index <= this.files.length - 1) {
        this.shownFile = {
          file: await this.files[index].file.arrayBuffer(),
          fileName: this.files[index].file.name,
          number: index + 1,
          download: this.files[index].download
        }
      }
      this.numberInputValue = this.shownFile.number
    },
    onNumberInputFocus: function (e) {
      this.numberInputPreviousValue = e.target.value
      e.target.select()
    },
    onNumberInputChange: function (e) {
      if (this.checkValidNumberInput(this.numberInputValue)) {
        this.changeShownFile(parseInt(this.numberInputValue) - 1)
      } else {
        this.numberInputValue = this.shownFile.number
      }
    },
    checkValidNumberInput: function (number) {
      return number !== '' && !isNaN(number) && parseInt(number) >= 1 && parseInt(number) <= this.files.length
    },
    downloadFile: async function () {
      const file = await this.getFile(this.shownFile.download)
      const link = document.createElement('a')
      const url = URL.createObjectURL(file)
      link.href = url
      link.download = file.name
      link.click()
      URL.revokeObjectURL(file)
    },
    mergePdfs: function () {
      const merger = new PDFMerger()
      const merge = (async () => {
        for (let i = 0; i<this.files.length; i++) {
          const file = this.files[i].file
          await merger.add(file)
        }
        return await merger.saveAsBlob()
      }).bind(this)

      return merge()
    },
    getFile: async function (url, name) {
      let file = null

      await AXIOS({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(async response => {
        file = new File ([response.data], name ? name : this.getFileName(response))
      }).catch(error => {
        this.$q.notify({
          type: 'warning',
          message: 'Не удалось загрузить файл, ' + error.message,
          progress: true,
          timeout: 8000
        })
      })
      return file
    },
    getFileName: function (response) {
      try {
        let headerLine = response.headers['content-disposition'];
        let startFileNameIndex = headerLine.indexOf('"') + 1
        let endFileNameIndex = headerLine.lastIndexOf('"');
        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
        filename = decodeURI(filename)
        return filename
      } catch {
        return undefined
      }
    },
    getFiles: async function (filesOrUrlsArray) {
      const files = []

      for (let i = 0; i<filesOrUrlsArray.length; i++) {
        const fileSrc = filesOrUrlsArray[i]
        if (typeof fileSrc.src === 'string') {
          let file = await this.getFile(fileSrc.src, fileSrc.name)
          if (file.name.includes('.docx')) {
            file.name = file.name.slice(0, file.name.length - 5) + '.pdf'
          }
          files.push({ file: file, download: fileSrc.downloadLink })
        } else if (fileSrc.src.isToUpload) {
          files.push({ file: fileSrc.src.file, download: fileSrc.downloadLink })
        } else {
          let file = await this.getFile(fileSrc.src.url, fileSrc.name)
          if (file.name.includes('.docx')) {
            file = new File([file], file.name.slice(0, file.name.length - 5) + '.pdf')
          }
          files.push({ file: file, download: fileSrc.downloadLink })
        }
      }
      return files
    },
    merge: async function () {
      try {
        let fileNames = this.files.map((el) => el.file.name.includes('.pdf') ? el.file.me.slice(0, el.file.name.length - 4) : el.file.name)
        let resultingFileName = fileNames.filter(el => el != 'null' && el != 'undefined' && el != '' ).join(',') + '.pdf'
        const file = await (await this.mergePdfs()).arrayBuffer()
        this.mergedPdfs = {
          file: file,
          fileName: resultingFileName
        }

      } catch {
        this.$q.notify({
          type: 'warning',
          message: 'Не удалось выполнить объединение файлов',
          progress: true,
          timeout: 8000
        })
      }
    },

    /**
     * Shows the viewer with specified configuration. Available from outside!
     *
     * @typedef {object} ViewerFileSrc
     * @property {any} src Blob, File or String url
     * @property {String} [downloadLink] Url for file download. If specified, the default download button will be replaced with button, downloading the file from the specified url
     * @property {String} [name] Specifies the name of the file. If not specified, file name will be set from 'content-disposition' header if present, otherwise - default
     *
     * @typedef {object} ViewerConfig
     * @property {Array.<ViewerFileSrc>} files Array of ViewerFileSrc objects
     * @property {Boolean} [readonly] If true, removes download and print buttons
     * @property {Boolean} [mergeFiles] If true, viewer will try to merge given files into one pdf document
     *
     * @param {ViewerConfig} config The configuration for viewer
     */
    show: function (config = {
      readonly: false,
      mergeFiles: true
    }) {
      this.loading = true

      this.showViewer = true

      let filesUrlsArray = config.files

      this.readonly = config.readonly

      Vue.nextTick(() => this.getFiles(filesUrlsArray).then(result => {
        this.files = result

        this.files[0].file.arrayBuffer().then(result => {
          Vue.set(this.shownFile, 'file', result)
          Vue.set(this.shownFile, 'fileName', this.files[0].file.name)
          Vue.set(this.shownFile, 'number', 1)
          Vue.set(this.shownFile, 'download', this.files[0].download)
        })

        if (filesUrlsArray.length > 1 && config.mergeFiles) {
          this.merge().finally(this.loading = false)
        } else {
          this.loading = false
        }
      }))

      this.numberInputValue = '1'

    },
    hide: function () {
      this.showViewer = false
      this.visible = false
      this.files = []
      this.shownFile = {}
      this.mergedPdfs = null
    }
  }
}
